// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__P4k2h","logo":"Navbar_logo__YJM-Q","time":"Navbar_time__p6+Cu"};